
import api from '@/api/website'
export var apiMixin = {

  data(){
    return{
      request_loading:false
    }
  },

  methods: {
  
    contact(data){
      return new Promise((resolve, reject) => {
        this.request_loading=true;
        api.contact(data).then(response=>{
          resolve(response);
        }).catch(error=>{
          reject(error);
        }).finally(()=>{
          this.request_loading=false;
        });
      })
    },
    booking_request(data){
      return new Promise((resolve, reject) => {
        this.request_loading=true;
        api.booking_request(data).then(response=>{
          resolve(response);
        }).catch(error=>{
          reject(error);
        }).finally(()=>{
          this.request_loading=false;
        });
      })
    },
    newsletter(data){
      return new Promise((resolve, reject) => {
        this.request_loading=true;
        api.newsletter(data).then(response=>{
          resolve(response);
        }).catch(error=>{
          reject(error);
        }).finally(()=>{
          this.request_loading=false;
        });
      })
    },
    confirmNewsletter(data){
      return new Promise((resolve, reject) => {
        this.request_loading=true;
        api.confirmNewsletter(data).then(response=>{
          resolve(response);
        }).catch(error=>{
          reject(error);
        }).finally(()=>{
          this.request_loading=false;
        });
      })
    }
  },
  created: function () {
  }
}
